import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CCard, CCardBody, CCardHeader, CCol, CFormCheck, CRow, CSmartTable } from '@coreui/react-pro';

import { formatDate, scrollToTopOffset } from '../../../../../utils';
import { DEFAULT_DATE_MONTH_NAME_TIME_FORMAT, SYSTEM_ADMIN_PATH, TEST_STATUS, USER_TEST_DETAIL_ADMIN_COLUMNS } from '../../../../../constants';

import { fetchAdminTestDetailsRequest } from '../Test/actions';
import { fetchAdminUserTestDetailsRequest } from './action';

const UserTestDetails = () => {
     const { id, userId } = useParams();
     const dispatch = useDispatch();
     const isLoading = useSelector((state) => state.general.isLoading);
     const test = useSelector((state) => state.admin.testDetails);

     const [userTestDetails, setUserTestDetails] = useState();
     const [questions, setQuestions] = useState([]);
     const [answerStatus, setAnswerStatus] = useState('all');
     const [page, setPage] = useState(1);

     const userTest = userTestDetails?.userTest;

     const statusClass = userTest?.status === TEST_STATUS.PASSED ? 'text-success' : 'text-danger';
     const scoresData = userTest ? `${userTest.scores}/${userTest.numberQuestion} (${userTest.status})` : '';

     const fetchSurveyDetails = () => {
          if (!test || test?.id !== id) {
               dispatch(fetchAdminTestDetailsRequest(id));
          }
     };

     const fetchUserTestDetails = () => {
          dispatch(fetchAdminUserTestDetailsRequest(id, userId, setUserTestDetails, setQuestions));
     };

     useEffect(() => {
          // Scroll to top
          scrollToTopOffset();

          fetchSurveyDetails();
          fetchUserTestDetails();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const onChangeAnswerStatus = (e) => {
          const status = e.target.value;
          setAnswerStatus(status);

          let newQuestions = [];
          if (status === 'all') {
               newQuestions = userTestDetails?.questions || [];
          }
          if (status === 'failed') {
               newQuestions = userTestDetails?.questions?.filter((q) => q.userAnswerCorrect === 'no');
          }
          if (status === 'passed') {
               newQuestions = userTestDetails?.questions?.filter((q) => q.userAnswerCorrect === 'yes');
          }

          setPage(1);
          setQuestions(newQuestions);
     };

     return (
          test && (
               <>
                    <div className="mb-2">
                         <Link className="mb-2" to={SYSTEM_ADMIN_PATH.TEST_USER_TESTS.replace(':id', id)}>{`< Go Back`}</Link>
                    </div>
                    <CCard className="mb-4">
                         <CCardHeader className="d-flex justify-content-between align-items-center">
                              <div className="card-header-text">
                                   <strong>User Test Details</strong>
                              </div>
                         </CCardHeader>
                         <CCardBody>
                              <CRow>
                                   <CCol md="4">
                                        <p>
                                             <strong>First Name:</strong> {userTestDetails?.user?.firstName}
                                        </p>
                                        <p>
                                             <strong>Last Name:</strong> {userTestDetails?.user?.lastName}
                                        </p>
                                        <p>
                                             <strong>Email:</strong> {userTestDetails?.user?.email}
                                        </p>
                                        {userTestDetails?.user?.phone && (
                                             <p>
                                                  <strong>Phone:</strong> {userTestDetails?.user?.phone}
                                             </p>
                                        )}
                                   </CCol>
                                   <CCol md="4">
                                        <p>
                                             <strong>Date Submit:</strong>{' '}
                                             {formatDate({ date: userTest?.createdAt, format: DEFAULT_DATE_MONTH_NAME_TIME_FORMAT })}
                                        </p>
                                        <p>
                                             <strong>User Time Zone:</strong> {userTestDetails?.user?.timezone}
                                        </p>
                                        <p>
                                             <strong>Scores:</strong> <span className={statusClass}>{scoresData}</span>
                                        </p>
                                   </CCol>
                                   <CCol md="12">
                                        <div className="filter-status-section">
                                             <CFormCheck
                                                  id="all"
                                                  type="radio"
                                                  name="answerStatus"
                                                  inline
                                                  value="all"
                                                  label="Show All"
                                                  onChange={onChangeAnswerStatus}
                                                  checked={answerStatus === 'all'}
                                                  disabled={isLoading}
                                             />
                                             <CFormCheck
                                                  id="failed"
                                                  type="radio"
                                                  name="answerStatus"
                                                  inline
                                                  value="failed"
                                                  label="Show only Failed Questions"
                                                  onChange={onChangeAnswerStatus}
                                                  checked={answerStatus === 'failed'}
                                                  disabled={isLoading}
                                             />
                                             <CFormCheck
                                                  id="passed"
                                                  type="radio"
                                                  name="answerStatus"
                                                  inline
                                                  value="passed"
                                                  label="Show only Passed Questions"
                                                  onChange={onChangeAnswerStatus}
                                                  checked={answerStatus === 'passed'}
                                                  disabled={isLoading}
                                             />
                                        </div>
                                   </CCol>
                                   <CCol md="12">
                                        <div className="table-responsive middle-table">
                                             <CSmartTable
                                                  pagination
                                                  activePage={page}
                                                  onActivePageChange={setPage}
                                                  columnSorter
                                                  clickableRows
                                                  itemsPerPage={20}
                                                  itemsPerPageSelect
                                                  loading={isLoading}
                                                  items={questions}
                                                  columns={USER_TEST_DETAIL_ADMIN_COLUMNS}
                                                  scopedColumns={{
                                                       index: (item, index) => <td>{index + 1}</td>,
                                                       answer: (item) => {
                                                            const userAnswer = item?.userAnswer?.charAt(0).toUpperCase() + item?.userAnswer?.slice(1);
                                                            const correctAnswer = item.answers.find((item) => item.isCorrect === 'yes').answer;
                                                            const correctAnswerFormat =
                                                                 correctAnswer.charAt(0).toUpperCase() + correctAnswer.slice(1);

                                                            if (item.userAnswerCorrect !== 'yes') {
                                                                 return (
                                                                      <td className="text-danger">
                                                                           {userAnswer}
                                                                           <br></br>
                                                                           <i className="text-success">Correct Answer: {correctAnswerFormat}</i>
                                                                      </td>
                                                                 );
                                                            }
                                                            return <td className="text-success">{userAnswer}</td>;
                                                       },
                                                  }}
                                             />
                                        </div>
                                   </CCol>
                              </CRow>
                         </CCardBody>
                    </CCard>
               </>
          )
     );
};

export default UserTestDetails;
